import { getOwnerId } from 'legacy/lut/selectors/app'
import { callJBPCommitmentDataInit } from 'legacy/lut/services/partner360/commitment/callJBPCommitmentDataInit'
import { fetchCommitmentData } from 'legacy/lut/services/partner360/commitment/fetchCommitmentData'
import { ICommitmentData } from 'legacy/lut/services/partner360/commitment/models/apiCommitmentData'
import { IFetchCommitmentDataParameters } from 'legacy/lut/services/partner360/commitment/models/fetchCommitmentDataParameters'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'
import { compose } from 'redux'

import { YEAR_WHEN_GP_APPEARS } from '../../../globalPartner/constants'
import { REQUEST_COMMITMENT_ITEMS } from '../constants'

export interface IRequestCommitmentItemsParameters
  extends Omit<IFetchCommitmentDataParameters, 'ownerId'> {}

export const requestCommitmentItems = createAsyncThunk<
  ICommitmentData[],
  IRequestCommitmentItemsParameters
>(
  REQUEST_COMMITMENT_ITEMS,
  async ({ partnerId, fYear, programType }, { getState }) => {
    const ownerId = compose(getOwnerId, getState)()
    const commitmentItems = await fetchCommitmentData({
      ownerId,
      partnerId,
      fYear,
      programType,
    })

    if (!commitmentItems.length) {
      return callJBPCommitmentDataInit({ ownerId, partnerId, fYear, programType })
    }

    return commitmentItems
  },
  {
    condition({ partnerId, fYear, programType }) {
      if (!partnerId || !fYear || !programType) {
        return false
      }

      if (partnerId.startsWith('GP') && fYear < YEAR_WHEN_GP_APPEARS) {
        return false
      }

      return
    },
  }
)
